import { createSlice } from '@reduxjs/toolkit'

export const colorsSlice = createSlice({
  name: 'colors',
  initialState: {
    value: {
      
      "lightblue": "#5ec7f2",
      "teal": "#148d73",
      "orange": "#f6a200",
      "brightgreen": "#63aa12",
      "lightteal": "#78c2ad",
      "darkgray": "#343a40",
      "gray":"#5a5a5a",
      "blue":"#0d6efd",
      "bs-blue":"#325d88",
      
      "indigo":"#6610f2",
      "purple":"#6f42c1",
      "pink":"#d63384",
      "red":"#dc3545",
      "orange":"#fd7e14",
      "yellow":"#ffc107",
      "green":"#198754",
      // "bs-teal":"#20c997",
      "cyan":"#0dcaf0",
      "white":"#fff",
      "bs-indigo":"#6610f2",
      "bs-purple":"#bdbac2",
      "bs-pink":"#e83e8c",
      "bs-red":"#d9534f",
      "bs-orange":"#f47c3c",
      "bs-yellow":"#ffc107",
      "bs-green":"#93c54b",
      "bs-teal":"#20c997",
      "bs-cyan":"#29abe0",
      "bs-black":"#000",
      "bs-white":"#fff",
      "bs-gray":"#8e8c84",
      "bs-gray-dark":"#3e3f3a",
      "bs-gray-100":"#f8f9fa",
      "bs-gray-200":"#f8f5f0",
      "bs-gray-300":"#dfd7ca",
      "bs-gray-400":"#ced4da",
      "bs-gray-500":"#98978b",
      "bs-gray-600":"#8e8c84",
      "bs-gray-700":"#495057",
      "bs-gray-800":"#3e3f3a",
      "bs-gray-900":"#212529",
      "bs-primary":"#325d88",
      "bs-secondary":"#8e8c84",
      "bs-success":"#93c54b",
      "bs-info":"#29abe0",
      "bs-warning":"#f47c3c",
      "bs-danger":"#d9534f",
      "bs-light":"#f8f5f0",
      // "bs-gray":"#6c757d",
      // "bs-gray-dark":"#343a40",
      // "bs-primary":"#0d6efd",
      // "bs-secondary":"#6c757d",
      // "bs-success":"#198754",
      // "bs-info":"#0dcaf0",
      // "bs-warning":"#ffc107",
      // "bs-danger":"#dc3545",
      // "bs-light":"#f8f9fa",
      // "bs-dark":"#212529"

    },
  },
  reducers: {
    change: (state) => {

      state.value = {...state.value}
    },


  },
})

// Action creators are generated for each case reducer function
export const {change } = colorsSlice.actions

export default colorsSlice.reducer